import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DOUBLE_OPT_IN_PETITION_LIST = createFcmDetails('double_opt_in_petition_list', {
	owner: 'Site Platform',
	context: 'monorail',
	description: 'Allows individual petitions to require double opt-in. Comma-separated list of petition IDs.',
	import: false,
});
